<template>
    <div class="MainWrapper">
        <router-view>
        </router-view>
    </div>



   



</template>

<script>
import vCatalogPage from './pages/v-catalogPage'


export default ({
  name: 'v_main_wrapper',
  components: {
    vCatalogPage
    },
    data () {
        return {

        }
    }


})



 
 
 
 
 
 
 
 
 

 
 
</script>

<style>

</style>